import { routes } from "@/data/routes";
import type { ThemeOption } from "@/constants";
import s from "./style.module.css";
export interface Input {
    defaultTheme?: ThemeOption;
}
static const colors = ["red", "blue", "marigold", "green"];
<let/open=false>

<icon-button
    aria-label="Open Site Nav"
    onClick() {
        open = true;
        navDialog().showModal();
    }>
    <nav-dialog-icon/>
</icon-button>
<dialog/navDialog
    class=s.dialog
    data-open=`${open}`
    onClick(e) {
        if (e.target === navDialog()) open = false;
    }
    onAnimationEnd(e) {
        if (e.target === navDialog()) navDialog().close();
    }
    onKeyDown(e) {
        if (e.key === "Escape") {
            e.preventDefault();
            open = false;
        }
    }>
    <div class=s.content>
        <div>
            <ul class=s.links>
                <for|route, i| of=routes>
                    <li>
                        <nav-link ...route color=colors[i % colors.length]/>
                    </li>
                </for>
            </ul>
        </div>
        <div class=s.header>
            <theme-switcher defaultTheme=input.defaultTheme/>
            <icon-button
                aria-label="Close Site Nav"
                autofocus
                onClick() {
                    open = false;
                }>
                <nav-dialog-icon name="close"/>
            </icon-button>
        </div>
    </div>
</dialog>
